var base = require('settings/preferences');
Vue.component('spark-preferences', {
    mixins: [base]
});
